import React from 'react';

import { Link } from 'gatsby';
import styled from 'styled-components';

import { Heading, Markdown, Button, SanityImage } from '../elements';

const BoxWrapper = styled.div`
  padding: 2rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  :hover {
    filter: drop-shadow(0px 20px 40px rgba(0, 0, 0, 0.25));
  }

  .link-wrapper {
    display: block;
    margin-top: auto;
  }
`;

const Hr = styled.hr`
  border-top: 3px solid ${(props) => props.theme.darkShades};
`;

const EmptySpace = styled.div`
  height: 2rem;
`;

const ServiceCard = ({ title, description, slug, image, alt, isLine }) => (
  <div className="column is-4">
    <BoxWrapper className="card is-borderless">
      {image && (
        <figure className="image is-64x64 mb-4">
          <SanityImage width={300} alt={alt} gatsbyImageId={image} />
        </figure>
      )}
      <div className="media">
        <div className="media-content">
          <Heading dark className="title is-5 is-uppercase">
            {title}
          </Heading>
          {isLine && <Hr />}
          {description && (
            <Markdown className="pb-2 has-text-grey-dark">
              {description}
            </Markdown>
          )}
          {isLine && <EmptySpace />}
        </div>
      </div>
      {slug && (
        <Link to={slug} className="link-wrapper">
          <Button fullWidth>Learn More</Button>
        </Link>
      )}
    </BoxWrapper>
  </div>
);

export default ServiceCard;
